import { memo } from "../Utils/index.mjs";
export const getApplyConfig = uri => config => (a, r, k) => (config && config[uri] ? config[uri] : a => a)(a, r[uri], k);
export function interpreter() {
  return i => memo(i);
}
//# sourceMappingURL=index.mjs.map